export default __webpack_public_path__ + "static/media/assign-template-blue.516f6062.svg";